<body>
    <div class="session">
        <div class="left">
            <!-- <svg enable-background="new 0 0 300 302.5" version="1.1" viewBox="0 0 300 302.5" xml:space="preserve"
                xmlns="http://www.w3.org/2000/svg">
                <style type="text/css">
                    .st01 {
                        fill: #fff;
                    }
                </style>
                <path class="st01"
                    d="m126 302.2c-2.3 0.7-5.7 0.2-7.7-1.2l-105-71.6c-2-1.3-3.7-4.4-3.9-6.7l-9.4-126.7c-0.2-2.4 1.1-5.6 2.8-7.2l93.2-86.4c1.7-1.6 5.1-2.6 7.4-2.3l125.6 18.9c2.3 0.4 5.2 2.3 6.4 4.4l63.5 110.1c1.2 2 1.4 5.5 0.6 7.7l-46.4 118.3c-0.9 2.2-3.4 4.6-5.7 5.3l-121.4 37.4zm63.4-102.7c2.3-0.7 4.8-3.1 5.7-5.3l19.9-50.8c0.9-2.2 0.6-5.7-0.6-7.7l-27.3-47.3c-1.2-2-4.1-4-6.4-4.4l-53.9-8c-2.3-0.4-5.7 0.7-7.4 2.3l-40 37.1c-1.7 1.6-3 4.9-2.8 7.2l4.1 54.4c0.2 2.4 1.9 5.4 3.9 6.7l45.1 30.8c2 1.3 5.4 1.9 7.7 1.2l52-16.2z" />
            </svg> -->
        </div>
        <form [formGroup]="form" class="log-in" (ngSubmit)="onSubmit()">
            <div *ngIf="isSignup" class="floating-label">
                <img src="../../../assets/images/logo/logo1.png" width="200" height="80">
                <br>
                <a href="https://link2future.ca/">
                    Back to Homepage</a>
            </div>


            <div *ngIf="isPasswordReset" class="floating-label">
                <img src="../../../assets/images/logo/logo1.png" width="200" height="80">
                <p>Please enter your email in order to reset your password</p>
            </div>
            <mat-form-field [color]="name.valid && 'accent'" *ngIf="isSignup" class="floating-label">
                <input matInput formControlName="name" type="text" placeholder="Name" autocomplete="off">

                <mat-error *ngIf="name.invalid && name.dirty">
                    Please enter your full name
                </mat-error>
            </mat-form-field>

            <mat-form-field [color]="email.valid && 'accent'" class="floating-label">
                <input matInput formControlName="email" type="email" placeholder="Email" autocomplete="off" />

                <mat-error *ngIf="email.invalid && email.dirty">
                    You must enter a valid email address
                </mat-error>
            </mat-form-field>

            <mat-form-field [color]="age.valid && 'accent'" *ngIf="isSignup" class="floating-label">
                <input matInput formControlName="age" type="number" placeholder="Age" autocomplete="off" />

                <mat-error *ngIf="age.invalid && age.dirty">
                    You must enter your age
                </mat-error>
            </mat-form-field>

            <mat-form-field [color]="country.valid && 'accent'" *ngIf="isSignup" class="floating-label">
                <input matInput formControlName="country" type="text" placeholder="Country" autocomplete="off">

                <mat-error *ngIf="country.invalid && country.dirty">
                    Please enter your country
                </mat-error>
            </mat-form-field>

            <mat-form-field [color]="interest.valid && 'accent'" *ngIf="isSignup" class="floating-label">
                <mat-label>Interest</mat-label>
                <mat-select formControlName="interest">
                    <mat-option *ngFor="let interest of interests" [value]="interest.value">
                        {{ interest.viewValue }}
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="interest.invalid && interest.dirty">
                    Please enter your interest
                </mat-error>
            </mat-form-field>

            <mat-form-field [color]="password.valid && 'accent'" *ngIf="!isPasswordReset" class="floating-label">
                <input matInput formControlName="password" type="password" placeholder="Password" autocomplete="off" />

                <mat-error *ngIf="password.invalid && password.dirty">
                    Password must be at least 6 characters long
                </mat-error>
            </mat-form-field>

            <mat-form-field [color]="passwordDoesMatch ? 'accent' : 'warn'" *ngIf="isSignup" class="floating-label">
                <input matInput formControlName="passwordConfirm" type="password" placeholder="Confirm password"
                    autocomplete="off" />

                <mat-error *ngIf="passwordConfirm.dirty && !passwordDoesMatch">
                    Password does not match
                </mat-error>
            </mat-form-field>

            <mat-error class="server-error">{{ serverMessage }}</mat-error>

            <div *ngIf="isPasswordReset">
                <a (click)="changeType('login')">Back to Login</a>
            </div>

            <button *ngIf="isPasswordReset" mat-stroked-button type="submit" [disabled]="loading">
                Send Reset Email
            </button>

            <div *ngIf="isSignup" class="floating-label">
                <p>Already have an account? Please <a (click)="changeType('login')" routerLink="/auth">Log
                        in</a></p>
            </div>

            <div *ngIf="isLogin" class="floating-label">
                <p>Don't have an account? Please <a (click)="changeType('signup')">Register</a></p>
            </div>

            <div *ngIf="isLogin && !isPasswordReset" class="floating-label">
                <a (click)="changeType('reset')">Forgot your password?</a>
            </div>

            <button *ngIf="!isPasswordReset" mat-raised-button color="primary" type="submit"
                [disabled]="form.invalid || !passwordDoesMatch || loading">
                Submit
            </button>
        </form>
    </div>
</body>